import React, { useMemo } from "react";

const SpecialText = ({ text }) => {

	const textHTML = useMemo(() => {
		const textAr = text.split("");
		let html = "";
		let tagOpen = false;
		let tagBuffer = "";
		let wordOpen = false;
		let charCount = 0;
		let inStrong = false; // ✅ track strong state

		for (let i = 0; i < textAr.length; i++) {
			const char = textAr[i];

			// inside HTML tag
			if (char === "<") {
				tagOpen = true;
				tagBuffer = "<";
				continue;
			}

			if (tagOpen) {
				tagBuffer += char;
				if (char === ">") {
					// ✅ tag finished
					const tagName = tagBuffer.toLowerCase();

					if (tagName.startsWith("<strong")) {
						inStrong = true;
					} else if (tagName.startsWith("</strong")) {
						inStrong = false;
					} else if (tagName.startsWith("<br")) {
						if (wordOpen) {
							html += "</span>";
							wordOpen = false;
						}
						html +=
							"<span class=\"c-special-text__break\" style=\"display:block;width:100%\"></span>";
					} else {
						// keep other tags intact if needed
						html += tagBuffer;
					}

					tagOpen = false;
					tagBuffer = "";
				}
				continue;
			}

			// spaces
			if (char === " ") {
				if (wordOpen) {
					html += `<span class="c-special-text__char c-special-text__char--${charCount}">&nbsp;</span></span>`;
					charCount++;
					wordOpen = false;
				} else {
					html += char;
				}
				continue;
			}

			// start new word
			if (!wordOpen) {
				wordOpen = true;
				html += `<span class="c-special-text__word${
					inStrong ? " c-special-text__word--strong" : ""
				}"><span class="c-special-text__char c-special-text__char--${charCount}">${char}</span>`;
				charCount++;
			} else {
				// continue word
				html += `<span class="c-special-text__char c-special-text__char--${charCount}">${char}</span>`;
				charCount++;
			}
		}

		// close last word if needed
		if (wordOpen) {
			html += "</span>";
		}

		return html;
	}, [text]);

	return <span className="c-special-text" dangerouslySetInnerHTML={{ __html: textHTML }} />;
};

export default SpecialText;
